import 'regenerator-runtime/runtime' 

import Vue from 'vue'

import * as VeeValidate from 'vee-validate'
import "./vee-validate"
import App from './App.vue'
import i18n from './i18n'
import Buefy from 'buefy'
import FlagIcon from 'vue-flag-icon'

import router from '@/router'
import ApiService from "./services/ApiService"
import formatMoney from './plugins/formatMoney'

import store from './store'

import VueSimpleAlert from "vue-simple-alert";

import VueCookies from 'vue-cookies'
import analyticsMixin from './mixins/analyticsMixin';

Vue.use(VueSimpleAlert)
Vue.use(formatMoney, formatMoney)

Vue.config.productionTip = false

ApiService.init(process.env.VUE_APP_ROOT_API)
ApiService.farmadomiciliosApiURL = process.env.VUE_APP_FARMADOMICILIOS_API

Vue.use(VeeValidate)

Vue.use(Buefy, {
  defaultFieldLabelPosition: 'inside'
})

Vue.use(FlagIcon)

Vue.use(VueCookies)
Vue.$cookies.config('7d')
Vue.mixin(analyticsMixin);

const accessToken = store.state.auth.token;

if (accessToken) {
  ApiService.setHeader('authorization', `${accessToken}`);
}

ApiService.setHeader('x-request-public-key', process.env.VUE_APP_FARMADOMICILIOS_CLIENT_KEY)

new Vue({
  i18n,
  router,
  store,
  render: h => h(App)
}).$mount('#app')
